// EC-Portal
export const EC_PORTAL_PRODUCT_FRUITS_ENABLED_FLAG = "ECPortalProductFruits";
export const EC_PORTAL_SHOW_RETURN_PRICE = "ECPortal.ShowReturnPrice";
export const EC_PORTAL_REQUEST_NEW_DEVICE = "ECPortal.RequestNewDevice";
export const EC_PORTAL_SHOW_INVOICE_STATUS_COLUMN =
  "show_invoice_status_column";
export const EC_PORTAL_SHOW_EXPORT_CSV = "ECPortal.ShowExportCSV";

// Checkout
export const CHECKOUT_PRODUCT_FRUITS_ENABLED_FLAG = "checkout.productfruits";
export const ALWAYS_SHOW_LISSA_T_A_C_FLAG = "alwaysShowLissaTaC";
export const SHOW_CONTINUE_IDV_LATER_BUTTON = "showContinueIdvLaterButton";
export const CHECKOUT_SHOW_TRUSTPILOT_WIDGET = "checkout.showTrustpilotWidget";
export const CHECKOUT_IN_SESSION_TOPI = "InSessionCheckoutTopi";

// Seller
export const ALLOW_DUPLICATE_BASKET_ITEMS = "BundlesAllowDuplicateBasketItems";
export const SHOW_MULTIPLIER_PRICING_UPDATE_BANNER_ENABLED =
  "ShowMultiplierPricingUpdateBanner";
export const SELLER_SHOW_EGIS_ORDER_URL = "ShowEGISOrderUrl";
export const SELLER_PAGE_PRODUCT_FRUITS = "seller.productfruits";
export const SEE_ALL_OFFERS_RELEASE_FLAG = "SeeAllOffersRelease";
export const MULTIPLIER_CUSTOM_PRODUCT_CARD_TEXT_ENABLED =
  "ShowMultiplierCustomProductCardText";

// Shared
export const SENTRY_ENABLED_FLAG = "sentryEnabledInFront";
export const SEGMENT_ENABLED_FLAG = "logToSegment";
